
export function Trust() {
  const trustPoints = [
    {
      icon: 'ri-map-pin-line',
      title: 'Deep knowledge of local bylaws',
      description: 'We stay current on city-specific regulations, enforcement patterns, and licensing requirements across Metro Vancouver and beyond.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Experience navigating Bill 35',
      description: 'We understand provincial short-term rental legislation and how it interacts with municipal rules to keep you compliant.'
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Focused on owner occupants',
      description: 'Our strategies are designed specifically for homeowners who live in their properties, not absentee investors.'
    },
    {
      icon: 'ri-chat-check-line',
      title: 'Clear honest advice',
      description: 'We tell you the truth even when the answer is no. Your long-term protection matters more than a quick sale.'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A]">
            Why homeowners trust us
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {trustPoints.map((point, index) => (
            <div 
              key={index}
              className="bg-white border border-[#F0F0F0] rounded-2xl p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${point.icon} text-[#882629] text-3xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-3">
                {point.title}
              </h3>
              <p className="text-base text-[#505A5A]/70 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-lg text-[#505A5A] italic font-['Fraunces'] max-w-3xl mx-auto">
            Our job is not to sell you a rental strategy. It is to protect you while helping you earn.
          </p>
        </div>
      </div>
    </section>
  );
}
